module.exports = __webpack_public_path__ + "img/202306_01.73967d4d.jpg";